export const TEXT_CONTENT = {
  EVENTS: {
    CANCELLED_TITLE: "This event is cancelled.",
    CANCELLED_DESC: "Registration is unavailable.",
    BOOKING_CLOSED_TITLE: "Booking has closed for this event",
    BOOKING_CLOSED_PREFIX: "Booking closed on",
    NO_PRICE_POINTS: "No price points are currently available for booking",
    EVENT_FULLY_BOOKED:
      "This event is fully booked. No places are currently available.",
    ADD_TO_BASKET_LOADING: "Adding to basket...",
    ADD_TO_BASKET: "Add to basket",
    ADD_TO_BASKET_AND_VIEW: "Add to basket and checkout",
    ADD_TO_BASKET_AND_CONTINUE: "Add to basket",
    BOOKING_CLOSED: "Booking Closed",
    AVAILABLE_SOON: "Available Soon",
    CANCELLED: "Cancelled",
    BOOKINGS_CLOSE_PREFIX: "Bookings close on",
    LOADING: "Loading event...",
    NOT_FOUND_TITLE: "Event not found",
    NOT_FOUND_DESC: "The event you're looking for doesn't exist.",
    BACK_TO_EVENTS: "Back to events",
    LIMITED_PLACES: "Limited places available",
  },
};



